export default __webpack_public_path__ + "static/media/Ato_White_Logo.c4e56616.png";